<template>
  <div v-if="isDataNull(data)" :style="{marginTop: top + 'px'}"
       style="width: 100%;display: flex;flex-direction: column; align-items: center;position: absolute;">
    <img :src="url ?  url : defaultUrl" :style="{width: width + 'px',height: height + 'px'}">
    <span v-if="isText" style="margin-top: 10px;font-size: 18px;color: #666666;">{{text}}</span>
  </div>
</template>

<script>
/**
 * 用于无数据时的显示美化组件
 * @export
 */
export default {
  name: 'NoData',
  props: {
    /**
     * 传入数据用于判断当前是否显示 判断依据
     * array 空数组<br>
     * object 空对象<br>
     * string 空字符串<br>
     * Number 0<br>
     * val null<br>
     */
    data: {
      type: Object | Array | String | Number,
      default: null
    },
    /**
     * 显示图片
     */
    url: {
      type: String,
      default: ''
    },
    /**
     * 距离顶部距离*/
    top: {
      type: Number,
      default: 40
    },
    /**
     * 宽度,默认180
     */
    width: {
      type: Number,
      default: 150
    },
    /**
     * 高度,默认180
     */
    height: {
      type: Number,
      default: 150
    },
    /**是否显示提示文案*/
    isText: {
      type: Boolean,
      default: true
    },
    /**提示文案 只有当isText为true时显示*/
    text: {
      type: String,
      default: '暂无数据'
    }
  },
  data () {
    return {
      //默认图片路径
      defaultUrl: require('../../../../resource/img/device/pic_empty.png')
    }
  },
  methods: {
    /**
     * 判断Object,Array,是否为空.
     *
     * 1.Object支持判断是否为空对象.
     *
     * 2.Array 支持判断是否为空数组.
     *
     * 3.变量 判断结果为 变量如果为 null,undefined,"" 均返回true
     *
     * @param data 需要判断的变量
     * @return Boolean 类型
     */
    isDataNull (data) {
      if (data == null) // 判断是否为null
        return true
      if (typeof (data) == 'undefined') { // 判断是否为undefined
        return true
      } else if (typeof (data) == 'object') { // 判断是否为对象
        if (data instanceof Array) { // 判断是否是数组
          if (data.length <= 0) { // 判断数组是否为空
            return true
          }
        }
        let dataArr = Object.keys(data) //转换为数组
        if (dataArr instanceof Array) { // 判断是否是数组
          if (dataArr.length <= 0) { // 判断数组是否为空
            return true
          }
        }
        return false
      } else if (typeof (data) == 'string') {
        if (data == '') { // 判断是否为空字符串
          return true
        }
        return false
      }
      return false
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/comp/NoData/NoData.vue